import * as React from 'react'

import { Box, Icon, Table, Tag } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useIncidenceTaskTypes } from 'modules/bookkeepers/hooks/TaskTypesContext'
import type { IncidenceQueryData } from 'modules/bookkeepers/hooks/useGetIncidences'

interface Props {
  taskStatuses: IncidenceQueryData['taskStatuses']
}

const TaskStatuses = ({ taskStatuses }: Props) => {
  const taskTypes = useIncidenceTaskTypes()

  return (
    <>
      {taskTypes.map((taskType) => {
        const taskStatus = taskStatuses.find(
          (element) => element?.taskType?.title === taskType.title
        )

        return (
          <Table.Cell key={taskType.id}>
            {taskStatus?.completed ? (
              <Box alignItems="flexStart" maxWidth="s120">
                <Tag type="lime">
                  <Box component="span" aria-label="check">
                    <Icon.Small icon="check" color="lime1000" />
                  </Box>
                </Tag>
              </Box>
            ) : (
              <Box alignItems="flexStart" maxWidth="s120">
                <Tag type="radical">
                  <Box component="span" aria-label="uncheck">
                    <Icon.Small icon="close" color="radicalRed1000" />
                  </Box>
                </Tag>
              </Box>
            )}
          </Table.Cell>
        )
      })}
    </>
  )
}

export default observer(TaskStatuses)
